// extracted by mini-css-extract-plugin
module.exports = {"component":"filter-chip-list_component__YhDny","link":"filter-chip-list_link__YnOUw"};